import { State } from '../configure-store';
import { Context } from '../../types/config';

export const getAccountId = (state: State): string => state.teamDetails.targetAccountId;
export const getLocale = (state: State): string => state.locale;
export const getMsid = (state: State): string  => state.msid;
export const getIsSite = (state: State): boolean => !!state.msid;
export const getContext = (state: State): Context => getIsSite(state) ? 'site' : 'account';
